var React = require('react');

function IconTag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M744 482.5L404.1 142.6H64.2v339.9l339.9 339.9s102 102 204 0l136-136c-.1 0 101.9-102-.1-203.9zm-543.9-136c-37.5 0-68-30.4-68-68 0-37.5 30.4-68 68-68s68 30.4 68 68-30.4 68-68 68z","key":0}),React.createElement("path",{"d":"M914 482.5L574.1 142.6c-68-34-68 34-68 34S738.5 408.9 846 516.5c28.4 28.4 68 68 0 136l-170 170c-34 68 34 68 34 68l204-204c102-102.1 0-204 0-204z","key":1})]);
}

IconTag.displayName = "IconTag";

IconTag.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconTag;

IconTag.default = IconTag;
